import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {JSX, ReactNode} from 'react'
import Image from 'next/image'
import type {Block} from '@/services/kontent-ai/types'
import {loadImageFromKontentAI} from '@/image-loader'
import {IconListBlock, type IconListContentItem} from '../icon-list'
import {
	ReusableCTAButtonComponent,
	type CtaButtonContentItem,
} from '../cta-button'

export type ProductSectionModContentItem = IContentItem<{
	titleText: Elements.TextElement
	paragraphText: Elements.TextElement
	imageBanner: Elements.AssetsElement
	button: Elements.LinkedItemsElement<CtaButtonContentItem>
	list: Elements.LinkedItemsElement<IconListContentItem>
}>

interface ProductSectionProps {
	className: string
	title?: string
	introText?: string
	imageAltText?: string
	imageSrc: string
	children: ReactNode
}
const ProductSection = (props: ProductSectionProps): JSX.Element => {
	return (
		<div className={`py-8 ${props.className}`}>
			<div className="container-narrow text-center">
				<h2 className="mb-4">{props.title}</h2>
				<div className="content text-center">{props.introText}</div>
			</div>

			<div className="mt-6 items-center justify-between md:flex">
				<div className="text-center md:w-1/2">
					<Image
						alt={props.imageAltText || ''}
						className="pb-8 md:pb-0 md:pr-12"
						height={400}
						loader={loadImageFromKontentAI}
						src={props.imageSrc}
						width={400}
					/>
				</div>

				<div className="md:w-1/2">
					<div className="mb-6">{props.children}</div>
				</div>
			</div>
		</div>
	)
}

export const ProductSectionModBlock: Block<ProductSectionModContentItem> = ({
	block,
	...context
}) => {
	return (
		<div className="py-10">
			<ProductSection
				className="container-wide border-1 rounded-lg bg-gray-200 p-10 shadow-inner"
				imageSrc={block.elements.imageBanner[0]?.url || ''}
			>
				<h4 className="mb-4" data-kontent-element-codename="title_text">
					{block.elements.titleText}
				</h4>
				<p className="mb-4">{block.elements.paragraphText}</p>
				{block.elements.list[0] ? (
					<IconListBlock
						block={block.elements.list[0]}
						{...context}
					/>
				) : null}
				{block.elements.button[0] ? (
					<ReusableCTAButtonComponent
						block={block.elements.button[0]}
						{...context}
					/>
				) : null}
			</ProductSection>
		</div>
	)
}
